<app-action-button
  [facet]="'secondary-link'"
  [size]="small ? 'small' : undefined"
  [appTooltip]="(copied ? 'shared.common.copy-to-clipboard-done' : 'shared.common.copy-to-clipboard') | translate"
>
  <svg-icon [src]="copied ? iconCopied : iconCopy" (click)="copyText()"> </svg-icon>
</app-action-button>
